import React from 'react';
import classnames from 'classnames';
import classes from './user-links.scss';
const UserLinksGuest = ({
  onSignupClick,
  onLoginClick
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.link, classes.loginButton),
    onClick: onLoginClick,
    "data-span": "Login"
  }, "Log In"), /*#__PURE__*/React.createElement("span", {
    className: classes.link,
    onClick: onSignupClick,
    "data-span": "SignUp"
  }, "Sign Up"));
};
export default UserLinksGuest;